const esMessages = {

  "main.name": "Nombre",
  "main.sentiment": "Sentimiento",
  "main.urgency": "Urgencia",
  "main.language": "Idioma",
  "main.agent": "Agente",
  "main.property_name": "Nombre de la propiedad",
  "main.booking_number": "Número de reserva",
  "main.check_out": "Salida",
  "main.check_in": "Entrada",
  "main.adults": "Adultos",
  "main.corporate_code": "Código corporativo",
  "main.group_code": "Código de grupo",
  "main.promo_code": "Código promocional",
  "main.ai_response": "Respuesta de IA",
  "main.template_response": "Respuesta de plantilla",
  "main.converttoticket": "Convertir en ticket",
  "main.switch_property": "Cambiar propiedad",
  "main.Group_id": "ID de grupo",
  "main.integration_id": "ID de integración",
  "main.submit": "Enviar",
  "main.cancel": "Cancelar",
    "main.select_template": "Seleccionar una plantilla",
  "main.rooms": "Habitaciones",
  "main.rates": "Tarifas",

  //footer
  "footer.knowledge": "Conocimiento",
  "footer.home": "Inicio",
  "footer.help": "Ayuda",

  //ticket
  "ticket.thank_you": "Gracias por enviar el formulario",
  "ticket.ticket": "Ticket",
  "ticket.details": "Complete el formulario describiendo los detalles del ticket.",
  "ticket.select_category": "Seleccionar categoría",
  "ticket.category": "Categoría",
  "ticket.title": "Título",
  "ticket.notes": "Notas",
  "ticket.status": "Estado",
  "ticket.assigned_to": "Asignado a",
  "ticket.submit_form": "Enviar formulario",


  "main.total": "Total",
  "main.pastetooutlook": "Pegar en Outlook",
  "main.children": "Niños",
  "main.promocode": "Código promocional/corporativo/grupo",
  "main.exact_match_only": "Solo coincidencia exacta",
  "main.search": "Buscar",
  "main.no_rate_match": "No hay tarifas que coincidan con su selección. Modifique su búsqueda e inténtelo de nuevo.",
  "main.translate_to": "Traducir a",
  "main.regenerate": "Regenerar",
  "main.copy_text": "Copiar texto",
  "main.additional_instructions": "Instrucciones adicionales",

  "faq.helpcenter": "Centro de ayuda",
  "faq.reply.email.sabre.question": "¿Cómo respondo a un correo electrónico utilizando la automatización de correo electrónico Aven Hospitality Concierge?",
  "faq.reply.email.sabre.answer": "Abra el correo electrónico e inicie el complemento de Aven Hospitality. Puede elegir entre tres opciones: usar una plantilla predefinida, generar una respuesta con IA o convertir el correo electrónico en un ticket. Seleccione la opción que mejor se adapte a la consulta, revise la respuesta, realice las modificaciones necesarias y envíela directamente desde Outlook.",

  "faq.rates.availability.question": "¿Cómo agrego tarifas, disponibilidad y detalles de habitaciones a mi respuesta?",
  "faq.rates.availability.answer": "Use la función + Rates para ingresar detalles del huésped, como fechas y número de huéspedes, y Concierge insertará la disponibilidad y los precios correctos en su respuesta. También puede usar + Rooms para incluir descripciones e imágenes de habitaciones.",

  "faq.different.language.question": "¿Qué debo hacer si el correo electrónico está en otro idioma?",
  "faq.different.language.answer": "Aven Hospitality Concierge permite traducir los correos electrónicos entrantes a su idioma preferido, facilitando su comprensión. Después puede generar o editar una respuesta y traducirla nuevamente al idioma del huésped antes de enviarla.",

  "faq.pin.addin.question": "¿Cómo puedo asegurarme de que el complemento siempre esté disponible en Outlook?",
  "faq.pin.addin.answer": "Para mantener Aven Hospitality Concierge siempre visible, fije el complemento en Outlook. Esto permite que se abra automáticamente con cada correo electrónico.",

  "faq.knowledge.hub.question": "¿Qué es la opción de búsqueda del Knowledge Hub?",
  "faq.knowledge.hub.answer": "La búsqueda del Knowledge Hub permite encontrar rápidamente información específica de la propiedad directamente dentro de Outlook.",

  "faq.reply.email.myma.question": "¿Cómo respondo a un correo electrónico usando Myma?",
  "faq.reply.email.myma.answer": "Abra el correo electrónico e inicie el complemento Myma. Puede usar una plantilla, generar una respuesta con IA o convertir el correo electrónico en un ticket.",

  "faq.room.details.question": "¿Cómo agrego detalles de habitaciones a mi respuesta?",
  "faq.room.details.answer": "Use + Rooms para incluir descripciones e imágenes de habitaciones, ayudando a los huéspedes a comprender mejor sus opciones.",

  "faq.myma.different.language.question": "¿Qué debo hacer si el correo electrónico está en otro idioma?",
  "faq.myma.different.language.answer": "Myma permite traducir correos electrónicos entrantes a su idioma preferido y traducir la respuesta nuevamente al idioma del huésped antes de enviarla.",

  "faq.myma.pin.addin.question": "¿Cómo puedo asegurarme de que el complemento siempre esté disponible en Outlook?",
  "faq.myma.pin.addin.answer": "Para mantener Myma siempre visible, fije el complemento en Outlook. Esto permite abrirlo automáticamente con cada correo electrónico."

};
export default esMessages;